class PageHeader {
    constructor(options) {
        this.state = {
            is_visible: true,
            is_open: false,
            last_scroll: window.pageYOffset
        }

        this.options = options;
        this.options.html = document.querySelector('html');
        this.options.body = document.querySelector('body');

        window.requestAnimationFrame(() => { this.checkScroll(); });
        this.options.toggle_el.addEventListener('click', () => { this.toggleMenu(); });

        this.options.menu_item_els.forEach((el) => {
            el.addEventListener('click', (e) => { this.toggleMenuItem(e); });
        });

        this.options.search_toggle_el.addEventListener('click', (e) => { this.toggleSearchDropdown(e); });
        
        this.options.search_toggle_el.parentElement.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    
        document.body.addEventListener('click', (e) => {
            this.options.el.classList.remove('search-is-open');
        });
    }

    checkScroll() {
        let scrolling_down = false;

        if (window.pageYOffset > 120 && window.pageYOffset > this.state.last_scroll) {
            scrolling_down = true;
        }

        if (window.pageYOffset > 20) {
            this.options.el.classList.add('is-scrolled');
        } else {
            this.options.el.classList.remove('is-scrolled');
        }

        if (window.pageYOffset !== this.state.last_scroll) {
            this.state.is_visible = !scrolling_down;
            this.state.last_scroll = window.pageYOffset;

            if (this.state.is_visible) {
                this.options.el.classList.add('is-visible');
                this.options.body.classList.add('has-visible-header');
            } else {
                this.options.el.classList.remove('is-visible');
                this.options.body.classList.remove('has-visible-header');
            }
        }

        window.requestAnimationFrame(() => { this.checkScroll(); });
    }

    toggleMenu() {
        this.state.is_open = !this.state.is_open;
        this.options.el.classList.toggle('is-open', this.state.is_open);
        this.options.html.classList.toggle('prevent-scroll', this.state.is_open);
    }

    toggleMenuItem(e) {
        if (window.innerWidth < 1040) {
            e.preventDefault();
            e.target.closest('.has-subnav').classList.toggle('is-open')
        }
    }

    toggleSearchDropdown(e) {
        e.preventDefault();
        e.stopPropagation();
        this.options.el.classList.toggle('search-is-open');
    }
}

var page_header = new PageHeader({
    el: document.querySelector('[page-header]'),
    toggle_el: document.querySelector('[page-header-hamburger]'),
    search_toggle_el: document.querySelector('[page-header-search-toggle]'),
    menu_item_els: document.querySelectorAll('[page-header-menu-item]')
});